import React from 'react'
import { Link } from 'react-router-dom'
import { Navbar, Nav, Button } from "react-bootstrap";
import { Image } from "cloudinary-react";
import "../Styles/errorPage.css";

export default function ExhaustedPlanError() {
    return (
        <body>
            <Navbar expand="md" fixed="top" variant="dark">
        <Navbar.Brand className="pl-5" href="#">
          <Link to="/lift">
            <Image cloudName="projectnairon" 
            publicId="yconnector-asset/YConnector-Logo_dewjdd.png" 
            width="40%" alt="YConnector logo"
            className="d-inline-block align-top"
             />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
        <div className="d-md-block ml-md-auto">
            <Nav>
              <Nav.Link href="/lift-login">
                Login
              </Nav.Link>

              <Nav.Link href="/lift-create-account">
                <Button style={{backgroundColor: "#fff", color: "#2B52BA", border: "none"}}>SignUp</Button>
              </Nav.Link>

              
            </Nav>
          </div>
          <div className="ml-md-auto d-md-none mt-3">
            <Nav>
          <div className="ml-md-auto d-md-none mt-3">
          </div> 
              
            </Nav>
          </div>
        </Navbar.Collapse>
      </Navbar>
            
            <div className="errorBody">
            <h1 className="header">Oops!</h1>
            <p className="textBody">Your Subscription Have Expired
            </p>

            
              </div>
        </body>
    )
}
